import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "w-full px-4" };
const _hoisted_2 = { key: 0 };
import { CustomContentAiIcon } from '@gohighlevel/ghl-icons/24/custom';
import { FolderPlusIcon, PlusIcon, Upload01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIBreadcrumb, UIBreadcrumbItem, UIHeader, renderIcon, } from '@gohighlevel/ghl-ui';
import { h } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaHeaderv2',
    props: {
        currentFolderLevel: Object,
        contentAIEnable: Boolean,
    },
    emits: ["uploadMedia", "createFolder", "openImageGenerationForm", "onClickFolder"],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const emit = __emit;
        const primaryOptionSection = e => {
            switch (e) {
                case 'upload_file':
                    emit('uploadMedia');
                    break;
                case 'new_folder':
                    emit('createFolder');
                    break;
                default:
            }
        };
        const sortingOptions = [
            {
                label: 'Upload file',
                key: 'upload_file',
                icon() {
                    return h(renderIcon(Upload01Icon), null, {});
                },
            },
            {
                label: 'New Folder',
                key: 'new_folder',
                icon() {
                    return h(renderIcon(FolderPlusIcon), null, {});
                },
            },
        ];
        const onClickFolder = (folder) => {
            emit('onClickFolder', folder);
        };
        const openImageAI = () => {
            emit('openImageGenerationForm');
        };
        function removeDuplicates(data) {
            const uniqueIds = new Set();
            const uniqueData = [];
            data.forEach(item => {
                if (!uniqueIds.has(item._id)) {
                    uniqueIds.add(item._id);
                    uniqueData.push(item);
                }
            });
            return uniqueData;
        }
        return (_ctx, _cache) => {
            const _component_UITextSmMedium = _resolveComponent("UITextSmMedium");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UIHeader), {
                    id: "headerTag",
                    title: " ",
                    primaryText: _unref(t)('common.newUpload'),
                    secondaryText: _unref(t)('common.createAi'),
                    primaryActionIcon: _unref(PlusIcon),
                    secondaryActionIcon: _unref(CustomContentAiIcon),
                    primaryOptions: sortingOptions,
                    onPrimaryClick: primaryOptionSection,
                    onSecondaryClick: openImageAI,
                    secondaryButtonConfig: {
                        disabled: !__props.contentAIEnable,
                    },
                    primaryButtonDropdownConfig: {
                        placement: 'bottom',
                    }
                }, {
                    "title-extra": _withCtx(() => [
                        (__props.currentFolderLevel.length == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Media Storage"))
                            : (_openBlock(), _createBlock(_unref(UIBreadcrumb), {
                                key: 1,
                                separator: ">"
                            }, {
                                default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(removeDuplicates(__props.currentFolderLevel), (folder, index) => {
                                        return (_openBlock(), _createBlock(_unref(UIBreadcrumbItem), { key: index }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_UITextSmMedium, {
                                                    class: _normalizeClass([
                                                        index === __props.currentFolderLevel.length - 1
                                                            ? 'cursor-default text-curious-blue-500'
                                                            : 'text-gray-600',
                                                    ]),
                                                    onClick: ($event) => (onClickFolder(folder))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(folder === null || folder === void 0 ? void 0 : folder.name), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["class", "onClick"])
                                            ]),
                                            _: 2
                                        }, 1024));
                                    }), 128))
                                ]),
                                _: 1
                            }))
                    ]),
                    _: 1
                }, 8, ["primaryText", "secondaryText", "primaryActionIcon", "secondaryActionIcon", "secondaryButtonConfig"])
            ]));
        };
    }
});
